<template>
  <div class="d-flex justify-space-between">
    <h1 class="">Novo tipo</h1>
    <a class="text-decoration-none">
      <v-btn class="text-white" color="grey" href="/tipos-checklist">Cancelar</v-btn>
      <v-btn class="text-white" color="#FF5000" @click="store" v-bind:disabled="btn_disabled">Salvar</v-btn>
    </a>
  </div>
  <div>
    <v-text-field v-model="type_name" label="Nome" :rules="rules" hide-details="auto"></v-text-field>
  </div>

  <v-snackbar v-model="snackbar" :timeout="timeout">
    <v-icon class="ml-1"> mdi-information-outline </v-icon> {{ text }}
    <template v-slot:actions>
      <v-btn variant="text" @click="closeSnack"> Fechar </v-btn>
    </template>
  </v-snackbar>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import * as services from "@/services";
import { TypeMovingStoreRequest } from "@/dtos/typeMoving/TypeMovingStoreRequest";
import messages from "@/constants/messages";

@Options({
  components: {},
})
export default class TypeMovingCreateView extends Vue {
  public rules = [(value: any) => !!value || "Required.", (value: string) => (value && value.length >= 3) || "Min 3 characters"];
  public type_name = "";
  public messages = {};
  public isLoadingTable = true;
  public needleSearch = null;
  public snackbar = false;
  public text = "";
  public timeout = 10000;
  public btn_disabled = false;

  mounted(): void {
    this.messages = messages;
  }
  changeLoading(): void {
    this.isLoadingTable = !this.isLoadingTable;
  }

  closeSnack(): void {
    this.snackbar = false;
    this.$router.push("/tipos-checklist");
  }

  async store(event: any): Promise<void> {
    const storeRequest: TypeMovingStoreRequest = {
      type_name: this.type_name,
      custom_checklist_json: "",
    };

    const response = await services.TypeMovingService.storeNew(storeRequest);

    if (response.success) {
      this.text = messages.success;
      this.snackbar = true;
      this.btn_disabled = true;
    } else {
      this.snackbar = true;
      this.text = messages.fail;
    }
  }
}
</script>
<style lang="css">
.default-data-base {
  border: solid #efecec 0.4px;
}

.w-3 {
  width: 10px;
}

.h-3 {
  height: 10px;
}
</style>
